<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<h2><b>CONTENTS</b></h2>
<p class="bigspace">
</p><table>
<tbody><tr>
<td valign="top"><a href="#/html/07_foreword">Foreword</a></td>
</tr>
<tr>
<td valign="top"><a href="#/html/08_theshma">The <i>Sh’ma</i></a></td>
</tr>
<tr>
<td valign="top"><a href="#/html/09_introduction">Introduction—Introducing the <i>Sh’ma</i></a></td>
</tr>
</tbody></table>
<p class="mediumspace">
</p><h4><span href="#/html/10_part1" title="Link target outside of Sample">A CALL TO LISTEN</span></h4>
<p class="smallspace">
</p><table style="width:80%">
<tbody><tr>
<td valign="top"><span href="#/html/11_chap1" title="Link target outside of Sample">Chapter 1</span></td>
<td valign="top"><span href="#/html/11_chap1" title="Link target outside of Sample">Hear</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/12_chap2" title="Link target outside of Sample">Chapter 2</span></td>
<td valign="top"><span href="#/html/12_chap2" title="Link target outside of Sample">Isra’el</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/13_chap3" title="Link target outside of Sample">Chapter 3</span></td>
<td valign="top"><span href="#/html/13_chap3" title="Link target outside of Sample">The Lord Our God</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/14_chap4" title="Link target outside of Sample">Chapter 4</span></td>
<td valign="top"><span href="#/html/14_chap4" title="Link target outside of Sample">The Lord Is One</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/15_chap5" title="Link target outside of Sample">Chapter 5</span></td>
<td valign="top"><span href="#/html/15_chap5" title="Link target outside of Sample">Blessed Be His Glorious Name</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/16_chap6" title="Link target outside of Sample">Chapter 6</span></td>
<td valign="top"><span href="#/html/16_chap6" title="Link target outside of Sample">Whose Kingdom Is Forever And Ever</span></td>
</tr>
</tbody></table>
<p class="mediumspace">
</p><h4><span href="#/html/17_part2" title="Link target outside of Sample">A CALL TO LOVE</span></h4>
<p class="smallspace">
</p><table style="width:80%">
<tbody><tr>
<td valign="top"><span href="#/html/18_chap7" title="Link target outside of Sample">Chapter 7</span></td>
<td valign="top"><span href="#/html/18_chap7" title="Link target outside of Sample">And You Shall Love The Lord Your God</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/19_chap8" title="Link target outside of Sample">Chapter 8</span></td>
<td valign="top"><span href="#/html/19_chap8" title="Link target outside of Sample">With All Your Heart</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/20_chap9" title="Link target outside of Sample">Chapter 9</span></td>
<td valign="top"><span href="#/html/20_chap9" title="Link target outside of Sample">With All Your Being</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/21_chap10" title="Link target outside of Sample">Chapter 10</span></td>
<td valign="top"><span href="#/html/21_chap10" title="Link target outside of Sample">With All Your Resources</span></td>
</tr>
</tbody></table>
<p class="mediumspace">
</p><h4><span href="#/html/22_part3" title="Link target outside of Sample">A CALL TO DO</span></h4>
<p class="smallspace">
</p><table style="width:80%">
<tbody><tr>
<td valign="top"><span href="#/html/23_chap11" title="Link target outside of Sample">Chapter 11</span></td>
<td valign="top"><span href="#/html/23_chap11" title="Link target outside of Sample">Love Your Neighbor As Yourself</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/24_chap12" title="Link target outside of Sample">Chapter 12</span></td>
<td valign="top"><span href="#/html/24_chap12" title="Link target outside of Sample">On Your Heart</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/25_chap13" title="Link target outside of Sample">Chapter 13</span></td>
<td valign="top"><span href="#/html/25_chap13" title="Link target outside of Sample">Teach Them Carefully To Your Children</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/26_chap14" title="Link target outside of Sample">Chapter 14</span></td>
<td valign="top"><span href="#/html/26_chap14" title="Link target outside of Sample">Talk About Them</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/27_chap15" title="Link target outside of Sample">Chapter 15</span></td>
<td valign="top"><span href="#/html/27_chap15" title="Link target outside of Sample">Tie Them As A Sign</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/28_chap16" title="Link target outside of Sample">Chapter 16</span></td>
<td valign="top"><span href="#/html/28_chap16" title="Link target outside of Sample">Write Them</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/29_chap17" title="Link target outside of Sample">Chapter 17</span></td>
<td valign="top"><span href="#/html/29_chap17" title="Link target outside of Sample">Look, Remember, And Obey</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/30_chap18" title="Link target outside of Sample">Chapter 18</span></td>
<td valign="top"><span href="#/html/30_chap18" title="Link target outside of Sample">Bless The Lord Who Is Blessed</span></td>
</tr>
</tbody></table>
<p class="mediumspace">
</p><table style="width:100%">
<tbody><tr>
<td valign="top"><span href="#/html/31_finalthoughts" title="Link target outside of Sample">Final Thoughts—“Do You Love Me?”</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/32_glossary" title="Link target outside of Sample">Glossary of Hebrew Terms and Concepts</span></td>
</tr>
<tr>
<td valign="top"><span href="#/html/33_bibliography" title="Link target outside of Sample">Bibliography</span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?74008b48